import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useAccess } from "src/hooks/useAccess.hook";
import sidebarConfig from "./SidebarConfig";

// Guards a route by feature permission. If the selected team does not have view
// ("Y") access to `featureName`, the user is redirected to the first feature
// they can access (falling back to the 404 page if none).
const notASideBarLink = ["Finance", "ChargeZone", "Settings"];

const getFirstAccessiblePath = (access) => {
  const firstAllowed = (access ?? []).find(
    (item) =>
      item.view === "Y" &&
      item.featureName &&
      !notASideBarLink.includes(item.featureName) &&
      sidebarConfig[item.featureName]?.path
  );
  return sidebarConfig[firstAllowed?.featureName]?.path ?? "/pagenotfound";
};

export default function RequireAccess({ featureName, children }) {
  const hasAccess = useAccess(featureName, "V");
  const team = useSelectedTeam();

  if (!hasAccess) {
    return <Navigate to={getFirstAccessiblePath(team?.access)} replace />;
  }

  return children;
}

RequireAccess.propTypes = {
  featureName: PropTypes.string.isRequired,
  children: PropTypes.node,
};
